











    import {Vue, Component, Prop} from "vue-property-decorator";

    @Component
    export default class CloseBtn extends Vue {
        @Prop({default: 20}) size: number;
        @Prop({default: 20}) top: number;
        @Prop({default: 24}) right: number;
        @Prop({default: 1024}) fitTo: number;  // размер, в который надо вписать кнопку вместе с паддингом
        @Prop({default: false}) mobileFriendly: boolean; // добавлять паддинг к кнопке для улучшения отзывчивости на мобильных устройствах
        @Prop({default: true}) isEnabledBg: boolean; // отображать подложку

        static recommendedMinimumSize = 44;

        get cssStyle(): Record<string, any> {
            return {
                top: this.mobileFriendly ? `${this.top-this.padding}px` : `${this.top}px`,
                right: this.mobileFriendly ? `${this.right-this.padding}px` : `${this.right}px`,
                padding: `${this.padding}px`,
                width: `${this.outerSize}px`,
                height: `${this.outerSize}px`
            }
        }

        get circleCssStyle(): Record<string, any> {
            return {
                top: `${-Math.floor((this.circleDiameter - this.size)/2) + this.padding}px`,
                left: `${-Math.floor((this.circleDiameter - this.size)/2) + this.padding}px`,
                width: `${this.circleDiameter}px`,
                height: `${this.circleDiameter}px`
            }
        }

        get circleDiameter() {
            const strictDiameter = Math.floor(this.size * 1.8);
            return strictDiameter % 2 === 0 ? strictDiameter : strictDiameter + 1;
        }

        get outerSize(): string {
            return `${this.size + this.padding}px`;
        }

        get innerSize(): string {
            return `${this.size}px`;
        }

        get padding(): number {
            return this.mobileFriendly ? Math.max((Math.min(CloseBtn.recommendedMinimumSize, this.fitTo) - this.size) / 2, 0) : 0;
        }
}
